"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseWasmData = void 0;
const encoding_1 = require("@cosmjs/encoding");
function parseWasmData({ key, val }) {
    return {
        key: encoding_1.fromHex(key),
        val: encoding_1.fromBase64(val),
    };
}
exports.parseWasmData = parseWasmData;
//# sourceMappingURL=types.js.map